import { createContext, useEffect, useReducer } from "react";
import Client from "../tools/client";
import Tools from "../tools/tools";
import { tokenName } from "../config";

const client = new Client();
const tools = new Tools();

// Context shape
export const UserContext = createContext({
  currentUser: null,
  setCurrentUser: () => null,
});

// Actions
export const USER_ACTION_TYPES = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
};

// Reducer
const userReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ACTION_TYPES.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type} in userReducer`);
  }
};

// Initial state
const INITIAL_STATE = {
  currentUser: null,
};

// Provider
export const UserProvider = ({ children }) => {
  const [{ currentUser }, dispatch] = useReducer(userReducer, INITIAL_STATE);

  const setCurrentUser = (user) => {
    dispatch({ type: USER_ACTION_TYPES.SET_CURRENT_USER, payload: user });
  };

  useEffect(() => {
    const hydrateUser = async () => {
      const token = localStorage.getItem(tokenName);
      if (!token) {
        localStorage.removeItem(tokenName);
        return;
      }

      try {
        const account = await client.getAccount();

        if (account?.status === "inactive") {
          tools.logOut();
          return;
        }

        setCurrentUser(account);
      } catch (err) {
        console.error("Failed to hydrate user:", err);
        localStorage.removeItem(tokenName);
      }
    };

    hydrateUser();
  }, []);

  const value = { currentUser, setCurrentUser };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};